export default {
  SUPER_ADMIN: 'super_admin',
  ORG_ADMIN: 'org_admin',
  ORG_USER: 'org_user',
  NORMAL_USER: 'normal_user',
};
